import { render, staticRenderFns } from "./color-selector.vue?vue&type=template&id=243f8b90&scoped=true"
import script from "./color-selector.vue?vue&type=script&lang=js"
export * from "./color-selector.vue?vue&type=script&lang=js"
import style0 from "./color-selector.vue?vue&type=style&index=0&id=243f8b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f8b90",
  null
  
)

export default component.exports